// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersView-wrapper .filtersSection {
  margin-bottom: 24px;
}
.FiltersView-wrapper .countSection {
  margin: 24px 0px;
  min-height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchTerritoriesPage/components/WinninTopicsTab/components/FiltersView/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,gBAAA;AADJ","sourcesContent":[".FiltersView-wrapper {\n  .filtersSection {\n    margin-bottom: 24px;\n  }\n\n  .countSection {\n    margin: 24px 0px;\n    min-height: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
